import { SectionHeader } from "~/components/SectionHeader";
import { cn } from "~/lib/utils";
import { dataRoomPillClassName } from "~/modules/asset_screener/components/AssetResultRow";

// // // //

/**
 * PageSection
 * Section header for an asset screener list - title, optional "Data Room
 * Available" badge, asset count, and a right-aligned slot for the sort control.
 * Copied from ~/modules/asset_screener/pages/listing/AssetScreenerListingPage.tsx
 * - `count` is optional (hidden while the first page is loading)
 * - the sort control is passed in as `children` (it reads/writes the sort via
 *   FilterFormSortField, so no sortBy / onSortByChange props)
 */
export function PageSection(props: {
    title: string;
    hasDataRoomBadge: boolean;
    count?: number;
    className?: string;
    children?: React.ReactNode;
}) {
    const { title, hasDataRoomBadge, count, className, children } = props;

    return (
        <div className={className}>
            <SectionHeader label={title}>
                <div className="flex w-full flex-wrap items-center gap-3 md:ml-3 md:min-w-0 md:flex-1">
                    {hasDataRoomBadge && (
                        <span
                            className={cn(
                                dataRoomPillClassName,
                                "rounded-md border whitespace-nowrap",
                            )}
                        >
                            Data Room Available
                        </span>
                    )}
                    {count !== undefined && (
                        <span className="text-sm font-normal text-tertiary-foreground">
                            {count.toLocaleString()} asset
                            {count !== 1 ? "s" : ""}
                        </span>
                    )}
                    {children && (
                        <div className="ml-auto w-full sm:w-auto sm:min-w-[180px] sm:max-w-[240px]">
                            {children}
                        </div>
                    )}
                </div>
            </SectionHeader>
        </div>
    );
}
